import { render, staticRenderFns } from "./_MainMenuElement.vue?vue&type=template&id=4636c066&scoped=true&"
import script from "./_MainMenuElement.vue?vue&type=script&lang=js&"
export * from "./_MainMenuElement.vue?vue&type=script&lang=js&"
import style0 from "./_MainMenuElement.vue?vue&type=style&index=0&id=4636c066&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636c066",
  null
  
)

export default component.exports